import {SingletonService} from '@/common/dependency.configs'
import {injectable} from 'inversify'

@SingletonService
@injectable()
export default class BltAddressText {
  format(city: string | undefined, state: string | undefined, zipCode: string | undefined) {
    const value = `${city ? city + ',' : ''} ${state || ''} ${zipCode || ''}`.trim()
    if (value.endsWith(',')) {
      return value.substring(0, value.length - 1) //remove comma
    }
    return value
  }
}
